module.exports = __webpack_public_path__ + "static/media/logo2.20581df8.jpg";